/* eslint-disable sort-keys-fix/sort-keys-fix */
import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const PHOTOS_PAGE = 'Photos page';

export const PHOTOS_PAGE_EVENTS = Object.freeze({
  PHOTOS_SMS_SEND: ({ enquiryId, isApiSuccess }: { enquiryId: number; isApiSuccess:boolean }) =>
    GENERIC_ANALYTICS_EVENTS.API_TRIGGERED({
      action: 'send_sms',
      backend_entity: String(enquiryId),
      backend_service: 'N/A',
      success: isApiSuccess,
      value: enquiryId,
    }),
  REQUEST_NEW_SMS: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: PHOTOS_PAGE,
    name: 'Photo page - SMS button click',
  }),
});
